import React from "react";
import { cn } from "./cn";
import { StatusGlyph } from "../../../assets/ui/icons";

/* Profile-status badge — the single place any status pill is rendered. */

// Design export's raw `state` -> canon status + membership.
const STATE_MODEL = {
  listed: { status: "listed", member: false },
  secondary: { status: "claimed", member: false }, // interim record -> Claimed
  accessed: { status: "claimed", member: true }, // Claimed + paying Member
  verified: { status: "verified", member: true },
};

export const resolveStatus = (company = {}) => {
  const fromState = STATE_MODEL[company?.state];
  if (fromState) return fromState;

  // Live API shape — mirrors the precedence the production card already uses:
  // verified wins, then member, then claimed, else listed.
  if (company?.verifiedCompany) return { status: "verified", member: true };
  if (company?.profile_status === "member") return { status: "claimed", member: true };
  if (company?.claimed) return { status: "claimed", member: false };
  return { status: "listed", member: false };
};

const STATUS = {
  listed: {
    label: "Listed",
    className: "bg-[var(--slate-2)] text-[var(--muted)] border-[var(--line)]",
  },
  claimed: {
    label: "Claimed",
    className:
      "bg-[var(--claimed-bg)] text-[var(--navy)] border-[var(--claimed-border)]",
  },
  verified: {
    label: "Verified",
    className:
      "bg-[var(--success-soft)] text-[var(--success)] border-[var(--verified-border)]",
  },
};

export const StatusBadge = ({ status = "listed", className = "" }) => {
  const s = STATUS[status] || STATUS.listed;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 h-[26px] px-[11px] rounded-full border",
        "text-[12px] font-semibold tracking-[.01em] whitespace-nowrap font-sans",
        s.className,
        className
      )}
    >
      <StatusGlyph kind={status} />
      {s.label}
    </span>
  );
};

/* Convenience wrapper for callers holding a whole company object. */
export const CompanyStatusBadge = ({ company, className = "" }) => (
  <StatusBadge status={resolveStatus(company).status} className={className} />
);

export default StatusBadge;
